/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import '../bootstrap';
import '../plugins';
//import Vue from 'vue';
//import Chosen from 'chosen-js';

//window.Vue = Vue;
import Splide from '@splidejs/splide';
//import AutoNumeric from 'autonumeric';

var loadTimeout = false;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
alt='{{$device->name}}'// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
/*
const app = new Vue({
    el: '#app',
});
*/

/* Lazy load */
document.addEventListener("DOMContentLoaded", function () {
    var e = [].slice.call(document.querySelectorAll("img.lazy-image"));
    if ("IntersectionObserver" in window) {
        let n = new IntersectionObserver(function (e, t) {
            e.forEach(function (e) {
                if (e.isIntersecting) {
                    let t = e.target;
                    (t.src = t.dataset.src), t.classList.remove("lazy-image"), n.unobserve(t);
                }
            });
        });
        e.forEach(function (e) {
            n.observe(e);
        });
    }
});

$(document).ready(function () {
	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});
		
	//fake navigation links
	$('span.nav-link').click(function(event){
		event.preventDefault();
		window.location = $(this).attr("data-href");
	});
	
	var splides = document.querySelectorAll('.splide');
	// 1. query slider elements: are there any splide elements?
	if(splides.length){
		
		const x = $(window).width();
		switch (true) {
			case (x < 767):
				var perPage = 1;
				break;
			case (x < 991):
				var perPage = 2;
				break;
			case (x < 1200):
				var perPage = 3;
				break;
			default:
				var perPage = 4;
				break;
		}
		
		
		
		// 2. process all instances
		for(var i=0; i<splides.length; i++){
			
			var interval = Math.floor(Math.random() * (4000 - 2000 + 1) + 2000);
			
			var splideElement = splides[i];
			//3.1 if no options are defined by 'data-splide' attribute: take these default options
			var splideDefaultOptions = 
			{
				perPage     : perPage,
				perMove :1,
				autoplay    : true,
				pauseOnHover: false,
				arrows:false,
				resetProgress:true,
				rewind:true,
				pagination:false,
				interval:interval,
			}
			/**
			* 3.2 if options are defined by 'data-splide' attribute: default options will we overridden
			* see documentation: https://splidejs.com/guides/options/#by-data-attribute
			**/
			
			var splide = new Splide( splideElement, splideDefaultOptions ); 
			// 3. mount/initialize this slider
			splide.mount();
		}
	}
	
		
	$( "body" ).on( "click", ".show-image",function( event ) {	
		event.preventDefault();	
		
		$('#lg-image').attr('src',$(this).attr('data-thumbnail'));
		$('#imageModal').modal('show');
	});
		
	$("#ajax-register").click(function(event){
		event.preventDefault();
		$("#status").html("");
		$.ajax({
			url: baseUrl+"/register",
			type:"POST",
			data:$("#frmRegister").serialize(),
			success:function(response){
			},
			statusCode: {
				200: function() {
					$("#frmRegister")[0].reset();
					$("#status").html('<div class="alert alert-info">Votre compte a été créé avec succès. Un mail de confirmation vous a été envoyé.</div>');
					$("#register-modal").hide();
					$("#login-modal").show();
				},
				422: function(response) {
					
					var errors="";
					for (var error in response.responseJSON['errors']) {
						errors=errors+response.responseJSON['errors'][error] + '<br>';
					}				
					$("#status").html('<div class="alert alert-danger">'+errors+'</div>');
				}
			 },
		});
	});
	
	$("#ajax-login").click(function(event){
		event.preventDefault();
		$("#status").html("");
		$.ajax({
			url: baseUrl+"/login",
			type:"POST",
			data:$("#frmLogin").serialize(),
			success:function(response){
				console.log(response);
			},
			statusCode: {
				200: function(response) {
					//success
					reset_token(response['csrf']);
					$("#frmLogin")[0].reset();
					$("#status").html('<div class="alert alert-info">Vous êtes connecté.</div>');
					$(".guest").hide();$(".logged").show();
					setTimeout(function() {$('#loginModal').modal('hide');}, 2000);
				},
				499:function(response) {
					//account not confirmed
					reset_token(response.responseJSON['csrf']);					
					$("#status").html('<div class="alert alert-danger">Votre compte n\'est pas encore confirmé. Veuillez cliquer sur le lien reçu par email.</div>');
				},
				498:function(response) {
					//user deactived				
					$("#status").html('<div class="alert alert-danger">Votre compte a été désactivé.</div>');
				},
				422: function(response) {
					//general error (validation...)
					var errors="";
					for (var error in response.responseJSON['errors']) {
						errors=errors+response.responseJSON['errors'][error] + '<br>';
					}				
					$("#status").html('<div class="alert alert-danger">'+errors+'</div>');
				}
			 },
		});
	});
	
	function reset_token(token){
		$('meta[name="csrf-token"]').attr('content', token);					
		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});
	}
	
	$(".show-register").click(function(event){
		event.preventDefault();
		$("#register-modal").show();
		$("#login-modal").hide();
	});
	
	$(".show-login").click(function(event){
		event.preventDefault();
		$("#login-modal").show();
		$("#register-modal").hide();
	});
		
	function scrollTo(id){
		if ($(id+"-desktop-anchor").length){
			$('html,body').animate({
				scrollTop: $(id+"-desktop-anchor").offset().top - $(".navbar").height() - 150
			}, 'slow');			
		}
		if ($(id+"-mobile-anchor").length){
			$('html,body').animate({
				scrollTop: $(id+"-mobile-anchor").offset().top - $(".navbar").height()
			}, 'slow')
		}
	}
	
	$("#more").click(function(event){
		$("#outro").css("max-height", "none");
		$("#more").hide();
	});
});

